'use client';

import classNames from 'classnames';
import { HTMLAttributes, ReactNode } from 'react';

interface IconContainerProps extends HTMLAttributes<HTMLDivElement> {
  icon: ReactNode;
}

const IconContainer = ({ className, icon, ...rest }: IconContainerProps) => {
  return (
    <div
      className={classNames(
        'dark:bg-base-300 text-gray-default dark:text-base-content flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-gray-100',
        className
      )}
      {...rest}>
      {icon}
    </div>
  );
};

export default IconContainer;
